export const DEFAULT_ASSISTANT_LOADING_MESSAGES = Object.freeze([
  '답변을 생성중입니다...',
  '앞선 문맥을 읽고 있습니다...',
  '더 좋은 답변을 위해 생각중입니다...',
  '관련 정보를 수집하고 있습니다...',
  '답변을 정리하고 있습니다...',
]);

export const DEFAULT_ASSISTANT_LOADING_MESSAGE_INTERVAL_MS = 2000;
